// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueProjets = (newValue) => ({
  type: actionTypes.SET_VALUE_PROJET,
  payload: newValue,
});

export const setCurrentPageProjets = (newCurrentPage) => ({
  type: actionTypes.SET_CURRENT_PAGE_PROJET,
  payload: newCurrentPage,
});

export const setSortingProjets = (newSorting) => ({
  type: actionTypes.SET_SORTING_PROJET,
  payload: newSorting,
});
export const setPageSizeProjets = (newValue) => ({
  type: actionTypes.SET_PAGE_SIZE_PROJET,
  payload: newValue,
});

export const setCustomFilterProjets = (newValue) => ({
  type: actionTypes.SET_CUSTOM_FILTERS_PROJET,
  payload: newValue,
});
export const setSortFieldProjets = (newSortField) => ({
  type: actionTypes.SET_SORT_FIELD_PROJET,
  payload: newSortField,
});
export const setOrderProjets = (newOrder) => ({
  type: actionTypes.SET_ORDER_PROJET,
  payload: newOrder,
});
export const setActiveTabProjets = (newActiveTab) => ({
  type: actionTypes.SET_ACTIVE_TAB_PROJET,
  payload: newActiveTab,
});
export const setQueryProjets = (newQuery) => ({
  type: actionTypes.SET_QUERY_PROJET,
  payload: newQuery,
});
export const setActifProjets = (newQuery) => ({
  type: actionTypes.SET_ACTIF_PROJET,
  payload: newQuery,
});
export const setSelectedOptionFiltersProjets = (newQuery) => ({
  type: actionTypes.SET_SELECTED_OPTION_FILTERS_PROJET,
  payload: newQuery,
});
export const setSelectedOptionIdProjets = (newQuery) => ({
  type: actionTypes.SET_SELECTED_OPTION_ID_PROJET,
  payload: newQuery,
});

export const setColumnProjets = (newValue) => ({
  type: actionTypes.SET_COLUMN_PROJET,
  payload: newValue,
});
